import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/Frontend-web-next/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource-variable+bricolage-grotesque@5.3.0/node_modules/@fontsource-variable/bricolage-grotesque/wght.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource-variable+dm-sans@5.3.0/node_modules/@fontsource-variable/dm-sans/wght.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource+poppins@5.3.0/node_modules/@fontsource/poppins/400.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource+poppins@5.3.0/node_modules/@fontsource/poppins/500.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource+poppins@5.3.0/node_modules/@fontsource/poppins/600.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fontsource+poppins@5.3.0/node_modules/@fontsource/poppins/700.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/Frontend-web-next/src/app/globals.css");
